import { FaUserShield } from "react-icons/fa";
import Toggle from "modules/swiftboard/components/ui/Toggle";
import { SectionShell, ToggleRow } from "./settings-shared";

export default function PrivacySection({ formData, onChange }) {
  return (
    <SectionShell id="privacy" icon={FaUserShield} title="Privacy" subtitle="Control what teammates can see about you">
      <ToggleRow label="Show online status" description="Let teammates see when you're active">
        <Toggle checked={!!formData.show_online_status} onChange={(v) => onChange("show_online_status", v)} />
      </ToggleRow>
      <ToggleRow label="Show email address" description="Visible on your profile to other users in your company">
        <Toggle checked={!!formData.show_email} onChange={(v) => onChange("show_email", v)} />
      </ToggleRow>
      <ToggleRow label="Show phone number" description="Visible on your profile to other users in your company">
        <Toggle checked={!!formData.show_phone} onChange={(v) => onChange("show_phone", v)} />
      </ToggleRow>
    </SectionShell>
  );
}
